$(document).ready(function() {
    $('.js-hamburger-reciever').on('click', function () {
        if($(this).is(':checked')) {
            $('.js-navbar-mobile').slideDown();
            $('body').addClass('no-scroll');
        }else {
            $('.js-navbar-mobile').slideUp();
            $('body').removeClass('no-scroll');
        }
    });
})
